import React from 'react';
import {useRouter} from '../../../../../@casino/useRouter';
import clsx from 'clsx';
import {useStyles} from './helpers';

const BlockButton = ({submit}) => {
    const router = useRouter();
    const classes = useStyles();
    
    return (
        <div className={classes.wrapBlockButton}>
            <span   
                className={clsx(classes.save, classes.bgSave)}
                onClick={() => submit()}
            >
                Сохранить
            </span>
            <span 
                className={clsx(classes.save, classes.bgCansel)}
                onClick={() => router.history.push('/bonuses/bonus')}
            >
                Отмена
            </span>
            <span
                className={clsx(classes.save, classes.bgOffBonus)}
            >
                Удалить бонус
            </span>
        </div>
    )
}

export default BlockButton;